import { defineComponent as _defineComponent } from 'vue'
import ProBadge from '../pro/ProBadge.vue'

export interface MoreOptionsItemProps {
  title: string
  showProBadge?: boolean
  link: string | undefined
  isExternal?: boolean
  component: 'NuxtLink' | 'a'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoreOptionsItem',
  props: {
    title: null,
    showProBadge: { type: Boolean, default: false },
    link: null,
    isExternal: { type: Boolean, default: true },
    component: null
  },
  setup(__props: any) {



return { __sfc: true,ProBadge }
}

})